<template>
  <div>
    <div class="search_box">
      <el-form :inline="true" ref="formSearch" :model="recordSearch" label-width="100px" label-position="right">
        <el-form-item label="买家账号:">
          <el-input v-model="recordSearch.pin" style="width: 280px"></el-input>
        </el-form-item>
        <el-form-item label="手机号码:">
          <el-input v-model="recordSearch.mobile" style="width: 280px"></el-input>
        </el-form-item>
        <el-form-item label="订单编号:">
          <el-input v-model="recordSearch.orderId" style="width: 280px"></el-input>
        </el-form-item>
        <el-form-item label="短信内容:">
          <el-input v-model="recordSearch.content" style="width: 280px"></el-input>
        </el-form-item>
        <el-form-item label="发送状态:">
          <el-select v-model="recordSearch.status" placeholder="请选择:" style="width: 280px">
            <el-option label="全部" value=""></el-option>
            <el-option label="已发送" value="1"></el-option>
            <el-option label="未发送" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发送时间:" class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="recordSearch.sentTimeStart"
            type="datetime"
            placeholder="开始时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions0"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px; font-size: 12px"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="recordSearch.sentTimeEnd"
            type="datetime"
            placeholder="结束时间"
            size="small"
            :picker-options="pickerOptions1"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 145px; font-size: 12px"
            class="time2"
            :clearable="false"
          ></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTime"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </el-form-item>
        <el-form-item>
          <div class="search_item" style="margin-left: 34px; width: 336px">
            <el-button icon="el-icon-search" class="status_btn status_btn1" @click="getSmsSentRecordList1" :disabled="talbeLoading">查询</el-button>
            <el-button class="status_btn status_btn2" @click="resetBtn1">重置</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div style="color: #fe4d45; margin-bottom: 10px">
      注意： 关怀类短信改官方发送后无手机号返回；
    </div>
    <div class="table-box" style="margin-top: 4px">
      <el-table
        v-loading="talbeLoading"
        ref="multipleTable"
        :data="smsrecords"
        tooltip-effect="light"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%"
      >
        <template slot="empty">
          <div>
            <img src="@/assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column prop="desensitizePin" label="买家昵称" :show-overflow-tooltip="!allShow"></el-table-column>
        <el-table-column prop="mobile" label="手机号码" :show-overflow-tooltip="!allShow" width="100">
          <template slot-scope="scope">
            {{ scope.row.mobile || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="短信内容" min-width="300">
          <template slot="header">
            <span style="height: 40px; line-height: 40px; overflow: hidden">短信内容</span>
            <span
              class="table-message"
              v-if="!allShow"
              style="
                cursor: pointer;
                color: #3840c7;
                margin-left: 16px;
                line-height: 40px;
              "
              @click="allShowBtn(1)"
              >展开全部</span
            >
            <span
              class="table-message"
              v-if="allShow"
              style="
                cursor: pointer;
                color: #3840c7;
                margin-left: 16px;
                line-height: 40px;
              "
              @click="allShowBtn(2)"
              >单行显示
            </span>
          </template>
          <template slot-scope="scope">
            <div class="hoveTitle" v-if="!allShow">{{ scope.row.content | enVToChinese }}</div>
            <div v-if="allShow">{{ scope.row.content | enVToChinese }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="comfrom" label="提醒类型"></el-table-column>
        <el-table-column prop="smsNumber" label="实际扣费(条)" width="100"></el-table-column>
        <el-table-column label="发送状态" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.status | statusStr }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sendTime" label="发送时间" :show-overflow-tooltip="!allShow"></el-table-column>
      </el-table>
      <!-- <pagination
        @transferName="smsPaginationFunction"
        :total="total"
      ></pagination> -->
      <div style="padding: 20px 28px 30px; text-align: right; margin-bottom: 0px">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 50, 100, 500, 1000]"
          :total="total"
          :page-size="recordSearch.size"
          :current-page="recordSearch.current"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/pagination.vue";
import { getSmsSentRecordList } from "@/api/smsSentRecord";
export default {
  props: {
    smsTableList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Pagination,
  },
  data() {
    return {
      talbeLoading: false, //表格加载
      allShow: false, // 信息是否全部显示
      total: 0,
      recordSearch: {
        sentTimeStart: "", //发送开始时间
        sentTimeEnd: "", //发送结束时间
        // comfrom: "", //信息来由
        pin: "", //买家昵称
        mobile: "", //手机号码
        status: "", //发送状态 0未发送 1已发送 2黑名单失败 4(10分钟内容重复) 3过滤重复发送 5无效号码 6中差评拦截 7退款拦截 ,
        orderId: "", //订单编号
        // softType: "1", //1(订单关怀,掌柜预警) 2(会员营销)
        content: "", //短信内容
        current: 1, //当前页
        size: 10, //每页大小
      },
      mytimestart: "",
      mytimeend: "",
      smsrecords: [],
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.recordSearch.sentTimeEnd != "") {
            return time.getTime() > new Date(this.recordSearch.sentTimeEnd).getTime() - 8.64e7;
          } else {
            let endTime = new Date(this.recordSearch.sentTimeEnd).getTime();
            // 最小选择时间   (时间跨度不能大于一年时间)
            let minTime = endTime - 365 * 24 * 3600 * 1000;
            return time.getTime() < minTime || time.getTime() > Date.now();
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (!this.recordSearch.sentTimeStart) {
            return time.getTime() > Date.now() - 8.64e7;
          } else {
            let startTime = new Date(this.recordSearch.sentTimeStart).getTime();
            // 最大选择时间  （时间跨度不能大于一年）
            let maxTime = startTime + 365 * 24 * 3600 * 1000;

            return time.getTime() < startTime || time.getTime() > Date.now() || time.getTime() > maxTime - 8.64e7;
          }
        },
      },
    };
  },
  filters: {
    statusStr(status) {
      return {
        0: "未发送",
        1: "已发送",
        2: "黑名单失败",
        4: "10分钟内容重复",
        3: "过滤重复发送",
        5: "无效号码",
        6: "中差评拦截",
        7: "退款拦截",
      }[status];
    },
  },
  watch: {
    $route(to, from) {
      this.getSmsSentRecordList();
    },
  },

  computed: {
    taskTypeActive() {
      return this.$route.meta.taskType;
    },
  },
  created() {
    this.time();
    this.getSmsSentRecordList();
  },
  mounted(){
    // if (this.$route.query.industry) {
    // 我的使用策略跳转过来，发送时间取消默认状态，显示不填状态 
    //   this.clearTime()
    //   this.getSmsSentRecordList1()
    // }
  },
  methods: {
    time() {
      this.recordSearch.sentTimeStart = this.getDateStr(-30) + " 00:00:00";
      this.recordSearch.sentTimeEnd = this.getDateStr(0) + " 23:59:59";
    },
    clearTime() {
      this.recordSearch.sentTimeStart = "";
      this.recordSearch.sentTimeEnd = "";
    },
    resetBtn1() {
      this.recordSearch.sentTimeStart = this.getDateStr(-30) + " 00:00:00";
      this.recordSearch.sentTimeEnd = this.getDateStr(0) + " 23:59:59";
      this.recordSearch.pin = "";
      this.recordSearch.mobile = "";
      this.recordSearch.status = "";
      this.recordSearch.orderId = "";
      this.recordSearch.content = "";
      this.recordSearch.current = 1;
      this.recordSearch.size = 10;
      this.getSmsSentRecordList();
    },
    //主页分页事件
    handleSizeChange(val) {
      this.recordSearch.size = val;
      this.recordSearch.current = 1;
      this.getSmsSentRecordList();
    },
    handleCurrentChange(val) {
      //console.log(val);
      this.recordSearch.current = val;
      this.getSmsSentRecordList();
    },
    // 分页事件
    smsPaginationFunction(event) {
      this.recordSearch.current = event.current;
      this.recordSearch.size = event.pageSize;
      this.getSmsSentRecordList();
    },
    getSmsSentRecordList1() {
      this.recordSearch.current = 1;
      this.getSmsSentRecordList();
    },
    getSmsSentRecordList() {
      this.talbeLoading = true;
      let params = { ...this.recordSearch };
      for (var i in params) {
        if (params[i] == "") {
          delete params[i];
        }
      }
      getSmsSentRecordList({
        ...params,
        taskType: this.taskTypeActive,
      }).then((res) => {
        this.smsrecords = res.data.records;
        this.total = res.data.total;
        this.talbeLoading = false;
      });
    },
    /*
     * 短信是否是全部显示
     * */
    allShowBtn(type) {
      if (type == 1) {
        this.allShow = true;
      } else {
        this.allShow = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search_box {
  display: flex;
  justify-content: space-between;
  flex-flow: wrap;
  .search_item {
    display: flex;
    align-items: center;
    // margin-right: 79px;
    margin-bottom: 16px;
    color: #333;
    .status_btn {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
    }
    .status_btn1 {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
      &:active {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }
    .status_btn2 {
      color: #666666;
      border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
}
</style>
